import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as ConveyorAPI from './conveyorAPI';

export const writeConveyor = createAsyncThunk('conveyorWrite/write', async ({ title, lineQty, conveyorType, applyCode, body, tags, project }, { rejectWithValue }) => {
    // console.log('applyCode @WriteConveyor write API : ', applyCode);
    try {
        const response = await ConveyorAPI.writeConveyor({ title, lineQty, conveyorType, applyCode, body, tags, project });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const updateConveyor = createAsyncThunk('conveyorWrite/update', async ({ id, title, lineQty, conveyorType, applyCode, body, tags }, { rejectWithValue }) => {
    // console.log('applyCode @WriteConveyor update API : ', applyCode);
    
    try {
        const response = await ConveyorAPI.updateConveyor({ id, title, lineQty, conveyorType, applyCode, body, tags });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

const initialState = {
    title: '',
    body: {
        input: {},
        output: {},
        resistance: {},
        drives: [],
        belt: {},
        drivePulley: {},
        // driveComponent: {},
        fluidCouplings: null,
        gearCouplings: null,
        brakes: null,
        backstops: null,
        driveComponent: null,
        idler: null,
        // 빈 객체의 경우에는 몽고디비가 알아서 쓰지 않는다. 따라서, 필요한 경우 객체의 가장 마지막 단을 'null'로 해주면 된다. 
        structure: {
            summary: {
                girder: null,
            },
        },
        pulleys: null,
    },
    tags: [],
    conveyor: null,
    conveyorError: null,
    originalConveyorId: null,
    project: null,
    user: null,
    conveyorType: null,
    applyCode: null,
    isValidTension: null,
};

const conveyorWriteSlice = createSlice({
    name: 'conveyorWrite',
    initialState,
    reducers: {
        initialize: state => initialState,
        initializeInput: state => {
            state.body.input = initialState.body.input;
            state.body.output = initialState.body.output;
            state.body.resistance = initialState.body.resistance;
            // state.body.drives = initialState.body.drives;
            // state.body.belt = initialState.body.belt;
            // state.body.drivePulley = initialState.body.drivePulley;
            // state.body.fluidCouplings = initialState.body.fluidCouplings;
            // state.body.gearCouplings = initialState.body.gearCouplings;
            // state.body.brakes = initialState.body.brakes;
            // state.body.backstops = initialState.body.backstops;
            
        },
        changeField: (state, { payload: { key, value }}) => {
            state[key] = value;
        },
        changeBody: (state, { payload: { key, value }}) => {
            state.body[key] = value;
        },
        changeStructure: (state, { payload: { key, value }}) => {
            state.body.structure[key] = value;
        },
        changeWeightSummary: (state, { payload: { key, value }}) => {
            state.body.structure.summary[key] = value;
        },
        copyConveyor: (state, { payload: input }) => {
            state.body.input = input;
        },
        setOriginalConveyor: (state, { payload: conveyor }) => {
            state.title = conveyor.title;
            state.lineQty = conveyor.lineQty;
            state.conveyorType = conveyor.conveyorType;
            state.applyCode = conveyor.applyCode;
            state.body = conveyor.body;
            state.tags = conveyor.tags;
            state.project = conveyor.project;
            state.user = conveyor.user;
            state.originalConveyorId = conveyor._id;
        },
        addDrive: (state) => {
            state.body.drive.push({
                driveEfficiency: '',
                requiredPower: '',
                numberOfDrives: '',
                selectedMotor: '',
                motorWeight: '',
                numberOfPoles: '',
                hertz: '',
                rpmOfMotor: '',
                ratedMotorTorque: '',
                drivePulleyDia: '',
            });
        },
        removeDrive: (state, action) => {
            const index = action.payload;
            if (index >= 0 && index < state.body.drive.length) {
                state.body.drive.splice(index, 1);
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(writeConveyor.fulfilled, (state, { payload }) => {
                state.conveyor = payload;
                state.conveyorError = null;
            })
            .addCase(writeConveyor.rejected, (state, { payload }) => {
                state.conveyor = null;
                state.conveyorError = payload;
            })
            .addCase(updateConveyor.fulfilled, (state, { payload }) => {
                state.conveyor = payload;
                state.conveyorError = null;
            })
            .addCase(updateConveyor.rejected, (state, { payload }) => {
                state.conveyor = null;
                state.conveyorError = payload;
            })
    }
});

// 액션과 리듀서 내보내기
export const { initialize, initializeInput, changeField, changeBody, changeStructure, changeWeightSummary, copyConveyor, setOriginalConveyor, addDrive, removeDrive } = conveyorWriteSlice.actions;
export default conveyorWriteSlice.reducer;

/* 
const initialState = {
    title: '',
    body: {
        profile: {
            profileImageNumber: '',
            horizontalLength: '',
            verticalLift: '',
            maxInclination: '',
            lengthCoeff: '',
        },
        capacity: {
            designCapacity: '',
            materialConveyed: '',
            bulkDensity: '',
            surchargeAngle: '',
            beltWidth: '',
            tentativeBeltMass: '',
            beltSpeed: '',
            artificialFrictionCoeff: '',
            volumetricCapacity: '',
            materialLoad: '',
        },
        idler: {
            carryIdlerSpacing: '',
            returnIdlerSpacing: '',
            carryIdlerRotatingMass: '',
            returnIdlerRotatingMass: '',
            carryIdlerMass: '',
            returnIdlerMass: '',
            numberOfIdlers: {
                carry: '',
                SAC: '',
                impact: '',
                return: '',
                SAR: '',
                total: '',
            },
            weightOfIdlers: {
                carry: '',
                SAC: '',
                impact: '',
                return: '',
                SAR: '',
                total: '',
            },
        },
        belt: {
            carcassType: '',
            beltSafetyFactor: '',
            tentativeBeltStrenth: '',
            selectedBelt: '',
            beltStrength: '',
            topCover: '',
            bottomCover: '',
            plyNumber: '',
            plyWeight: '',
            plyThickness: '',
            beltUnitMass: '',
            tapeLength: '',
            beltWeight: '',
        },
        resistance: {
            mainResistance: '',
            frictionalResistance: '',
            noLoadResistance: '',
            slopeResistance: '',
            tractivePull: '',
        },
        tension: {
            laggingFrictionCoeff: '',
            wrapAngle: '',
            drivingFactor: [],
            minTensionForDriving: '',
            sag: '',
            minTensionDueToSag: {
                carrySide: '',
                returnSide: '',
            },
            slackSideTension: '',
            tightSideTension: '',
            PIW: '',
            actualBeltSF: '',
        },
        drive: [
            {
                driveEfficiency: '',
                requiredPower: '',
                numberOfDrives: '',
                selectedMotor: '',
                motorWeight: '',
                numberOfPoles: '',
                hertz: '',
                rpmOfMotor: '',
                ratedMotorTorque: '',
                drivePulleyDia: '',
            },
        ],
        driveComponent: {
            speedReducer: {
                reductionRatio: '',
                inertia: '',
                weight: '',
                frameSize: '',
            },
            fluidCoupling: {
                model: '',
                inertia: '',
                weight: '',
            },
            gearCoupling: {
                model: '',
                allowableTorque: '',
                maxRPM: '',
                inertia: '',
                weight: '',
            },
            brake: {
                model: '',
                torque: '',
                inertia: '',
                weight: '',
            },
            holdback: {
                model: '',
                torque: '',
                weight: '',
                normalCase: {
                    torque: '',
                    safetyFactor: '',
                },
                emergencyCase: {
                    torque: '',
                    safetyFactor: '',
                },
                torqueRequired: '',
            },
        },
    },
};
*/